import { PropTypes } from 'react';

export const storeShape = PropTypes.object.isRequired;



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/